/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    bool, object, shape, string,
} from 'prop-types';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ReactMarkdown from 'react-markdown';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import PROMO_QUERY from '../../../../../ContentTypeComponents/PromoQuery';

const styles = (theme) => ({
    root: {
        width: '100%',
        maxWidth: '1440px',
        boxSizing: 'border-box',
        padding: '5px',
        margin: '10px auto',
        textAlign: 'center',
        '& p': {
            padding: '0',
            margin: '0',
        },
        borderRadius: '2px',
        '@media screen and (max-width: 500px)': {
            margin: '0 auto 10px',
            borderRadius: '0',
            boxShadow: 'inset 0 5px 5px #00000020',
        },
    },
    rootUniversal: {
        maxWidth: '1400px',
        [theme.breakpoints.down(960)]: {
            margin: '0',
        },
    },
    details: {
        display: 'block',
        margin: '5px auto 0',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    dialogContent: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flex: '0 0 auto',
    },
    detailsLink: {
        '&:focus': {
            outline: 'none',
        },
    },
    closeButton: {
        padding: '16px 24px',
    },
});

const CheckoutBannerContent = ({ classes, data, isUniversal }) => {
    const [isModalOpen, changeModalState] = useState(false);

    const handleModal = (e, windowOpen) => {
        e.nativeEvent.stopImmediatePropagation();
        e.preventDefault();
        e.persist();
        e.stopPropagation();
        changeModalState(windowOpen);
    };
    const closeModal = (e) => handleModal(e, false);

    const content = data.findContent?.content?.entries?.[0]?.banner_copy || null;
    if (!content) return null;
    const details = data.findContent?.content?.entries?.[0]?.details || null;
    const detailsLinkCopy = data.findContent?.content?.entries?.[0]?.details_link_copy || 'Click here for details';
    const styleObj = data.findContent?.content?.entries?.[0]?.styling || {};
    const bannerStyles = {
        color: styleObj?.font_color?.color || '',
        // fontFamily: styleObj.font_family || '', //TODO: parse font family
        fontSize: styleObj?.font_size || '',
        backgroundColor: styleObj?.background_color?.color || '',
    };
    return (
        <>
            <Grid item xs={12}>
                <div style={bannerStyles} className={`${classes.root} ${isUniversal ? classes.rootUniversal : ''}`} data-testid="checkoutbanner">
                    <ReactMarkdown source={content} />
                    {details && <span className={classes.details} key={details} tabIndex={0} role="link" onKeyDown={() => {}} onClick={(e) => { handleModal(e, true, details); }}>{detailsLinkCopy}</span>}
                </div>
            </Grid>
            { isModalOpen
                    && (
                        <Dialog open={isModalOpen} onClick={closeModal}>
                            <div className={classes.dialogContent}>
                                <DialogTitle id="customized-dialog-title">
                                    Details for: {details}
                                </DialogTitle>
                                <IconButton data-testid="close-button" className={classes.closeButton} aria-label="close" onClick={closeModal}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                            <MuiDialogContent dividers>
                                <Typography gutterBottom>
                                    <PROMO_QUERY promocode={details} />
                                </Typography>
                            </MuiDialogContent>
                        </Dialog>
                    )}
        </>
    );
};
CheckoutBannerContent.propTypes = {
    classes: object.isRequired,
    data: shape({
        banner_copy: string,
        details: string,
        details_link_copy: string,
        styling: shape({
            font_family: string, font_size: string, color: string, backgroundColor: string,
        }),
        title: string,
    }).isRequired,
    isUniversal: bool,
};

CheckoutBannerContent.defaultProps = {
    isUniversal: false,
};

export default compose(
    withStyles(styles),
)(CheckoutBannerContent);
